
(function organizationalUnitConfigServiceDefinition() {
    'use strict';

    angular.module('Entities')
        .service('organizationalUnitConfigService', [
            'restUrlBuilder', function organizationalUnitConfigService(restUrlBuilder) {

                restUrlBuilder = restUrlBuilder('auth');

                this.getById = function getById(id) {
                    return restUrlBuilder.one('OrganizationalUnitConfigs', id)
                                         .get();
                };

                this.getAll = function getAll(assignable, assignableToOu, assignableToOuWithParent, index, count) {

                    var params = {
                        assignable: assignable,
                        assignableToOu: assignableToOu,
                        assignableToOuWithParent: assignableToOuWithParent
                    };

                    if (index) {
                        params.index = index;
                        params.count = count;
                    };

                    return restUrlBuilder.all('OrganizationalUnitConfigs')
                                         .get({ params: params });
                };
                
                this.create = function create(organizationalUnitConfig) {

                    if (organizationalUnitConfig == null) {
                        throw "organizationalUnitConfig no puede ser null";
                    }

                    return restUrlBuilder.all('OrganizationalUnitConfigs')
                                         .post(organizationalUnitConfig);
                };

                this.modify = function modify(organizationalUnitConfig) {
                    if (organizationalUnitConfig == null) {
                        throw "organizationalUnitConfig no puede ser null";
                    }

                    return restUrlBuilder.all('OrganizationalUnitConfigs')
                                        .put(organizationalUnitConfig);
                };

                this.getValue = function getValue(idOu, configName, metadata, trec) {
                    return restUrlBuilder.one('organizationalUnitConfigs/Config', idOu).custom(encodeURIComponent(configName)).custom(encodeURIComponent(metadata)).custom(trec).get();

                };

            }
        ]);

})();